var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"getBatchFile":_vm.getBatchFile}},[_c('a-input',{attrs:{"id":"file","type":"file","accept":".txt"},on:{"change":_vm.batchFile}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }